import {GetProp, UploadProps} from "antd";

export type UploadFileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
export const getBase64FromUpload = (file: UploadFileType | File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });